import * as React from 'react';
import Picky from 'react-picky';
import I18n from 'i18n-react';
import './CompaniesIdentity.css';
import { Input } from 'antd';

export default class CompaniesIdentity extends React.Component {
	dropDownField;
	selectAll;
	constructor(props) {
		super(props);
		this.state = {
			companiesList: props.companiesList,
			companiesIdentityOriginal: props.companiesIdentity,
			isTouched: props.isTouched,
			companiesIdentity: []
		};
		this.selectMultipleOption = this.selectMultipleOption.bind(this);
		this.closeDropdown = this.closeDropdown.bind(this);
		this.clearAll = this.clearAll.bind(this);
		this.scrollToElement = this.scrollToElement.bind(this);
	}

	componentDidMount() {
		const mountCompaniesIdentity = this.mountCompaniesIdentity(this.props.searchResult);
		this.setState({
			companiesList: mountCompaniesIdentity
		});

	}

	mountCompaniesIdentity(searchResult) {
		let flightsOption = [];
		if(searchResult){
		searchResult.forEach((search) => {
			search.cart.items.forEach((item) => {
				this.buildObjectCompanies(item.departureFlight, flightsOption);
				if (item.returnFlight)
					this.buildObjectCompanies(item.returnFlight, flightsOption);
			});

		});
		}
		return flightsOption;
	}

	buildObjectCompanies(flight, flightsOption) {
		let companyName;
		flight.flightGroup.forEach((group) => {
			companyName = group.marketingCarrier;
			if (companyName !== undefined) {
				if (flightsOption.filter((opt) => opt.id === companyName).length === 0)
					flightsOption.push({
						id: companyName,
						name: I18n.translate('company.' + companyName)
					});
			}
		})
	}

	createCompaniesString(companiesValue) {
		const companies = [];

		companiesValue.forEach((e) => {
			if (!companies.includes(e.id))
				companies.push(e.id);
		});
		return companies.length > 0 ? companies.join('-') : ''
	}

	selectMultipleOption(value) {
		this.action(value)
	}

	action = (value) =>
		new Promise(() => {
			this.setState({
				companiesIdentity: value
			});
			this.props.callbackCompaniesIdentity(this.createCompaniesString(value))
		});

	closeDropdown() {
		this.dropDownField.click();
	}

	clearAll() {
		const { companiesList } = this.state;
		const { companiesIdentity } = this.props;
		const companiesListExists = companiesList || [];
		const companiesIdentityExists = companiesIdentity || [];

		if (companiesListExists.length === companiesIdentityExists.length) {
			this.selectAll.click();
		}
		else {
			this.props.onTouched(false);
		}
	}

	scrollToElement() {
		const rect = this.dropDownField.getBoundingClientRect(),
			scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		let elementPosTop = rect.top + scrollTop;
		window.scroll({
			top: elementPosTop - 250,
			behavior: 'smooth'
		});
	}

	render() {
		const { companiesList, companiesIdentity, isTouched } = this.state;
		const companiesIdentityExists = companiesIdentity || [];
		const companiesListExists = companiesList || [];
		return (
				<div
					className="filter-wrapper ta-form-group"
					ref={field => this.dropDownField = field}
					onClick={this.scrollToElement}
				>
					<label className="control-label">{I18n.translate('filters.airCompany')}</label>
					<Picky
						id="dropdown"
						value={companiesIdentity}
						options={companiesList}
						onChange={this.selectMultipleOption}
						open={false}
						valueKey="id"
						labelKey="name"
						placeholder={!isTouched ? 'Todas as companhias' : 'Nenhuma selecionada'}
						multiple={true}
						includeFilter={false}
						dropdownHeight={295}
						numberDisplayed={5}
						className={`ta-dropdown -select ${companiesIdentityExists.length >= 0 ? 'selected' : ''} ${isTouched ? 'has-value' : ''}`}
						render={({ style, isSelected, item, selectValue, labelKey, valueKey }) => {
							const selectedItems = [];
							selectedItems.push(item);
							return (
									<li
										style={style}
										className={`ta-checkbox ${isSelected ? 'selected' : ''}`}
										key={item[valueKey]}
										onClick={() => selectValue(item)}
									>
										<Input type="checkbox" checked={isSelected} readOnly />
										<span>{item[labelKey]}</span>
									</li>
							);
						}}
						renderSelectAll={({
							filtered,
							tabIndex,
							toggleSelectAll,
							multiple,
						}) => {
							if (multiple && !filtered) {
								return (
									<div
										tabIndex={tabIndex}
										role="option"
										aria-selected="true"
										data-selectall="true"
										className={companiesListExists.length === companiesIdentityExists.length
											? 'option selected' : 'option'}
										onClick={toggleSelectAll}
										onKeyPress={toggleSelectAll}
										ref={all => this.selectAll = all}
									>
										<span>Selecionar todas</span>
									</div>
								);
							}
						}}
					/>
				</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/page/searchResultPage/components/CompaniesIdentity/CompaniesIdentity.jsx